"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceClassToToken = exports.addClassToToken = exports.toArray = exports.splitWithSpace = void 0;
const splitWithSpace = s => s ? s.split(' ') : [];
exports.splitWithSpace = splitWithSpace;
const toArray = a => Array.isArray(a) ? a : [a];
exports.toArray = toArray;
const addClassToToken = (token, classToAdd) => {
  const originalClasses = (0, exports.splitWithSpace)((token === null || token === void 0 ? void 0 : token.attrGet('class')) || "");
  return token.attrSet('class', [...originalClasses, ...classToAdd].join(' '));
};
exports.addClassToToken = addClassToToken;
const replaceClassToToken = (token, classToAdd) => {
  return token.attrSet('class', classToAdd.join(' '));
};
exports.replaceClassToToken = replaceClassToToken;
